export default "__VITE_ASSET__o$sEFTxT__"